export const BASE_URL = process.env.REACT_APP_APP_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;
export const WABOTTY_API = process.env.REACT_APP_WABOTTY_API;
export const NEW_ORDERS_URL = process.env.REACT_APP_NEW_ORDERS_URL;
export const IFOOD_IMAGES_FILE = process.env.REAT_APP_IFOOD_IMAGES_FILE;

//Images Url's
export const IMAGES_BASE_URL = "upsoft.s3.amazonaws.com/";
export const IMAGES_URL = "upsoft.s3.amazonaws.com/";
export const THUMBOR_URL = "https://images.upsoftbr.com/";

export const LOGIN_URL = API_URL + "auth/";
export const REFRESH_TOKEN_URL = API_URL + "refresh_token/";
export const DELIVERY = API_URL + "delivery/";
export const AUTH = API_URL + "auth/";
export const CONTACT_URL = API_URL + "contact/";
export const PAYMENTS_URL = API_URL + "payments/";
export const CUSTOMER_PAYMENTS_URL = API_URL + "customer_payments/";
export const PAYMENT_METHODS_URL = API_URL + "payment_methods/";
export const PAYMENT_GATEWAY_ACCOUNTS_URL =
  API_URL + "payment_gateway_accounts/";

export const PLACES_API = "https://geocode.search.hereapi.com/v1/geocode?";
export const GEOCODER_API = "https://geocoder.ls.hereapi.com/6.2/geocode.json?";
export const ACCOUNT_URL = API_URL + "account/";

export const SUPPORT_URL = API_URL + "support/";
export const WABOTTY_URL = API_URL + "wabotty/";
export const CHATS_URL = API_URL + "chats/";

export const SECURITY_URL = API_URL + "security/";
export const CAMPAIGNS_URL = API_URL + "campaigns/";
export const CAMPAIGN_LISTS_URL = API_URL + "campaign_lists/";
export const AI_URL = API_URL + "ai/";
export const QRCODE_URL = API_URL + "qrcode/";
export const CALENDAR_URL = API_URL + "calendar/";
export const CALENDAR_EVENTS_URL = API_URL + "calendar_events/";
export const TEMPLATES_URL = API_URL + "templates/";
export const AUTOMATIONS_URL = API_URL + "automations/";
export const AUTOMATIONS_RULES_URL = API_URL + "automations-rule/";
export const CONTACTS_URL = API_URL + "contacts/";
export const COLUMNS_URL = API_URL + "columns/";
export const CONTACT_GROUPS_URL = API_URL + "contact-groups/";
export const NOTIFICATIONS_URL = API_URL + "notifications/";
export const BUSINESS_HOURS_URL = API_URL + "business-hours/";
export const BUSINESS_EXCEPTIONS_URL = API_URL + "business-exceptions/";
export const BUSINESS_HOURS_SETTINGS_URL = API_URL + "business-hours-settings/";
export const APPOINTMENT_TYPES_URL = API_URL + "appointment-types/";
export const RECEIVED_MESSAGES_URL = API_URL + "received-messages/";
export const SENT_MESSAGES_URL = API_URL + "sent-messages/";
export const AGENT_TESTS_URL = API_URL + "ai/openai/function_calling/";
export const GOOGLE_API_URL = API_URL + "google-api/";
export const METRICS_URL = API_URL + "metrics/";
export const CLIENTS_URL = API_URL + "clients/";

export const USERS_URL = API_URL + "users/";
export const VALIDATE_CPF_URL = API_URL + "users/validate_cpf/";

// URLs específicas dos endpoints (opcionais - já incluídas nos services)
export const CREATE_USER_SECURE_URL = USERS_URL + "create_user_secure/";
export const GET_SUPERUSERS_URL = USERS_URL + "get_superusers/";
export const UPDATE_USER_PERMISSION_URL = (id) =>
  USERS_URL + `${id}/update_user_permission/`;
export const RESET_USER_PERMISSIONS_URL = (id) =>
  USERS_URL + `${id}/reset_user_permissions/`;

export const AI_AGENTS_URL = API_URL + "agents/";
export const AI_AGENTS_IMAGES_URL = API_URL + "images/";
export const AI_AGENTS_DRAFTS_URL = API_URL + "agents-drafts/";

// AI Agents Actions URLs
export const AI_AGENTS_GENERATE_PROMPT_URL = (id) => API_URL + `agents/${id}/generate_prompt/`;
export const AI_AGENTS_COPY_PROMPT_URL = (id) => API_URL + `agents/${id}/copy_prompt/`;
export const AI_AGENTS_EXPORT_URL = (id) => API_URL + `agents/${id}/export/`;
export const AI_AGENTS_ACTIVATE_URL = (id) => API_URL + `agents/${id}/activate/`;
export const AI_AGENTS_VERSIONS_URL = (id) => API_URL + `agents/${id}/versions/`;
export const AI_AGENTS_RESTORE_VERSION_URL = (id) => API_URL + `agents/${id}/restore_version/`;

export const AI_AGENTS_VERSION_DETAIL_URL = (id, version) =>
  API_URL + `agents/${id}/version_detail/?version=${version}`;
export const AI_AGENTS_CREATE_VERSION_URL = (id) =>
  API_URL + `agents/${id}/create_version/`;
export const AI_AGENTS_EXPORT_VERSION_URL = (id, version = null) => {
  const baseUrl = API_URL + `agents/${id}/export_version/`;
  return version ? `${baseUrl}?version=${version}` : baseUrl;
};

// AI Agents Testing URL (usar a existente AGENT_TESTS_URL)
export const AI_AGENTS_TEST_URL = AGENT_TESTS_URL;

// AI Agents Images Actions URLs
export const AI_AGENTS_IMAGES_BULK_UPLOAD_URL = API_URL + "images/bulk_upload/";

// AI Agents Drafts Actions URLs
export const AI_AGENTS_DRAFTS_CURRENT_URL = API_URL + "agents-drafts/current/";
export const AI_AGENTS_DRAFTS_SAVE_URL = API_URL + "agents-drafts/save_draft/";
export const AI_AGENTS_DRAFTS_CLEAR_URL = (id) => API_URL + `agents-drafts/${id}/clear/`;
export const AI_AGENTS_DRAFTS_CLEAR_EXPIRED_URL = API_URL + "agents-drafts/clear_expired/";

export const CUSTOMERS_URL = API_URL + "customers/";
export const CUSTOMER_TAGS_URL = API_URL + "customer-tags/";
export const CUSTOMER_TAG_ASSIGNMENTS_URL =
  API_URL + "customer-tag-assignments/";

//global tags
export const TAGS_URL = API_URL + "tags/";

// Customer Actions URLs
export const CUSTOMERS_BULK_UPDATE_URL = CUSTOMERS_URL + "bulk_update/";
export const CUSTOMERS_STATS_URL = CUSTOMERS_URL + "stats/";
export const CUSTOMERS_EXPORT_URL = CUSTOMERS_URL + "export/";
export const CUSTOMER_ADD_TAGS_URL = (id) => CUSTOMERS_URL + `${id}/add_tags/`;
export const CUSTOMER_REMOVE_TAGS_URL = (id) =>
  CUSTOMERS_URL + `${id}/remove_tags/`;

// Customer Tags Actions URLs
export const CUSTOMER_TAGS_USAGE_STATS_URL = CUSTOMER_TAGS_URL + "usage_stats/";
